import {
    buildParsedFooterFAQContent,
    type ParsedFooterFAQContent,
} from './parse-footer-content-to-faq-core';

export type { ParsedFooterFAQContent } from './parse-footer-content-to-faq-core';

/** Parses directory footer HTML in the browser for client-side navigations. */
export const parseFooterContentInBrowser = (
    html: string,
): ParsedFooterFAQContent => {
    if (!html || typeof DOMParser === 'undefined') {
        return { introHtml: '', faqItems: [] };
    }

    try {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return buildParsedFooterFAQContent(Array.from(doc.body.children));
    } catch (error) {
        console.error('Failed to parse footer content:', error);
        return { introHtml: '', faqItems: [] };
    }
};
